import { useEffect, useState } from 'react';
import geoLanguagesData from '@/app/common/api/backups/languages.json';
import geoLocationsData from '@/app/common/api/backups/locations.json';
import {
  DEFAULT_COUNTRY,
  DEFAULT_LANGUAGE,
  type CountryOption,
  type SelectOption
} from '@/app/KeywordResearch/components/keyword-massive/massiveFormConfig';

export const useMassiveGeoSelect = () => {
  const [countries, setCountries] = useState<CountryOption[]>();
  const [languages, setLanguages] = useState<SelectOption[]>();
  const [selectedCountry, setSelectedCountry] =
    useState<CountryOption>(DEFAULT_COUNTRY);
  const [selectedLanguage, setSelectedLanguage] =
    useState<SelectOption>(DEFAULT_LANGUAGE);

  useEffect(() => {
    setCountries(
      geoLocationsData.data.map(({ code, fa_name }) => ({
        value: code,
        label: fa_name,
        flag: `https://static.mizfa.tools/flags/${code}.webp`
      }))
    );
  }, []);

  useEffect(() => {
    setLanguages(
      geoLanguagesData.data.map(({ code, fa_name }) => ({
        value: code,
        label: fa_name
      }))
    );
  }, []);

  const handleCountryChange = (country: CountryOption) => {
    setSelectedCountry(country);

    const location = geoLocationsData.data.find(
      item => item.code === country.value
    );
    if (!location?.official_locaguage_code) return;

    const language = geoLanguagesData.data.find(
      item => item.code === location.official_locaguage_code
    );
    if (language) {
      setSelectedLanguage({
        value: language.code,
        label: language.fa_name
      });
    }
  };

  return {
    countries,
    languages,
    selectedCountry,
    selectedLanguage,
    setSelectedLanguage,
    handleCountryChange
  };
};
